import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DonationFormEditComponent } from './donation-form-edit/donation-form-edit.component';
import { FormListComponent } from './form-list/form-list.component';
import { FormSubmissionListComponent } from './form-submission-list/form-submission-list.component';
import { NewFormComponent } from './new-form/new-form.component';
import { RenewalFormEditComponent } from './renewal-form-edit/renewal-form-edit.component';
import { ProspectFormEditComponent } from './prospect-form-edit/prospect-form-edit.component';
import { GeneralFormEditComponent } from './general-form-edit/general-form-edit.component';

const routes: Routes = [
  { title: 'form-builder.title', path: 'new', component: NewFormComponent },
  { title: 'common.edit', path: 'donation/:id/edit', component: DonationFormEditComponent },
  { title: 'forms.form-builder.title', path: 'forms', component: FormListComponent },
  { title: 'common.edit', path: 'renewal/:id/edit', component: RenewalFormEditComponent },
  { title: 'common.edit', path: 'prospect/:id/edit', component: ProspectFormEditComponent },
  { title: 'common.submissions', path: 'form/:id/submissions', component: FormSubmissionListComponent },
  { title: 'common.edit', path: 'general/:id/edit', component: GeneralFormEditComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class FormBuilderRoutingModule {}
